import { Icon } from '@material-ui/core';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog.jsx';
import React, { useState } from 'react';
import styled from 'styled-components';
import DeleteBin from 'utils/images/bin.svg';

const SectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background: #ffffff;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  padding-left: 10px;
  margin-left: -32px;
  margin-right: -20px;
`;

const DeleteIconWrapper = styled.div`
  margin-right: 30px;
`;

const DeleteIcon = styled.img`
  width: 14px;
  cursor: pointer;
`;

const VenueImages = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  margin-left: 5px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 14px;
`;

const VenueImagePlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  background: #fafafa;
  border: 1px solid #dedede;
`;

const VenueName = styled.p`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 16px;
  letter-spacing: -0.4px;
  color: #000000;
`;

const VenueUrl = styled.span`
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: -0.2px;
  color: #797979;

  @media (max-width: 900px) {
    font-size: 10px;
  }
`;

const UrlWrapper = styled.div`
  margin-left: 10px;
`;

const BinBorder = styled.div`
  text-align: left !important;
  width: 30px;
  height: 30px;
  cursor: pointer;
  clear: both;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 15px;
  padding: 5px 0px 5px 7px;
`;

const ParticipantDetails = ({ name, slug, imageSrc, remove }) => {
  const [showDeleteVenueConfirmation, setShowDeleteVenueConfirmation] =
    useState(false);

  const handleRemove = () => {
    remove();
    setShowDeleteVenueConfirmation(false);
  };

  return (
    <SectionContainer>
      <IconWrapper>
        <div>
          <Icon style={{ color: ' #C4C4C4' }}>drag_indicator</Icon>
        </div>
        <div>
          {imageSrc ? (
            <VenueImages src={imageSrc} alt="venue image" />
          ) : (
            <VenueImagePlaceholder />
          )}
        </div>
        <UrlWrapper>
          <VenueName>
            {name || ''}
            <br />
            <VenueUrl>
              {' '}
              {`${process.env.REACT_APP_CUSTOMER_APP_URL}/venue/${slug || ''}`}
            </VenueUrl>
          </VenueName>
        </UrlWrapper>
      </IconWrapper>

      <DeleteIconWrapper>
        <BinBorder onClick={() => setShowDeleteVenueConfirmation(true)}>
          <DeleteIcon src={DeleteBin} alt="Delete" />
        </BinBorder>
      </DeleteIconWrapper>

      <ConfirmationDialog
        open={showDeleteVenueConfirmation}
        variant="yesNo"
        onConfirm={handleRemove}
        onClose={() => {
          setShowDeleteVenueConfirmation(false);
        }}
        confirmationDescription=""
        confirmationTitle="Confirm you want to remove this venue"
      />
    </SectionContainer>
  );
};

export default ParticipantDetails;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupEditor/ParticipantDetails/index.jsx